export function writeCssRule(selector, rules, mediaQuery) {
  if (mediaQuery) {
    return `${mediaQuery} { ${selector} { ${rules} } }`;
  }
  return `${selector} { ${rules} }`;
}